import copyAccountsList from "./list.vue"
import paperTypeList from "./paperTypeList.vue"
import paperTypeEdit from "./paperTypeEdit.vue"
import addRecord from "./addRecord.vue"
import copyASummary from "./copyASummary.vue"
import accountingStatement from "./accountingStatement.vue"

let a = Object.assign({ copyAccountsList, paperTypeList, paperTypeEdit, addRecord, copyASummary, accountingStatement })
export default a